import * as React from "react";
import { fetchData } from "../../common/services/ApiClient";
import { ApiBaseUrl } from "../../config";
import { KeyValue, SimpleTableRow, TableHeader } from "../../interfaces";
import MultiHeaderTable from "../MultiHeaderTable/MultiHeaderTable";
import SimpleTableBody from "../MultiHeaderTable/SimpleTableBody";

interface Props {
  cert: number;
  risdate: string;
}
export default function InterstateOfficesTable({ cert, risdate }: Props) {
  const [interstateData, setInterstateData] = React.useState<KeyValue[]>([]);
  const headerMetaData: KeyValue[] = [
    {
      title: "State",
      apiField: "STNAME",
      styles: { textAlign: "left" },
    },
    {
      title: "Number of Offices",
      apiField: "unique_count",
      styles: {},
    },
  ];
  const tableHeaders: TableHeader[][] = [
    headerMetaData.map(element => ({
      title: element.title,
      styles: element.styles,
      colSpan: 1,
      apiField: element.apiField,
    })),
  ];
  React.useEffect(() => {
    if (interstateData.length === 0) {
      let isMounted = true;
      let formattedRisDate = risdate;
      if (risdate.includes("/")) {
        const splitRisDate = formattedRisDate.split("/");
        formattedRisDate = `${splitRisDate[2]}${splitRisDate[0]}${splitRisDate[1]}`;
      }

      (async () => {
        await fetchData(
          `${ApiBaseUrl()}/events?agg_by=STNAME&filters=!OFF_SERVTYPE:26 ORG_END_NUM_DTE:>=${formattedRisDate} AND ORG_EFF_NUM_DTE:<=${formattedRisDate} AND CERT:${cert} AND BANK_INSURED:Y AND !CLASS:CU&get_unique=UNINUM`,
        )
          .then(response => {
            if (isMounted) {
              const transformedData = (tableData: KeyValue[]) => {
                return tableData.map((data: KeyValue) => {
                  const tableCellData: SimpleTableRow = {};

                  headerMetaData.forEach((value: KeyValue) => {
                    const apiField = value.apiField;
                    tableCellData[apiField ? apiField : value.title] = {
                      value: data[apiField],
                      styles: value.styles,
                    };
                  });

                  return tableCellData;
                });
              };
              setInterstateData(
                transformedData(
                  response.data.filter((data: KeyValue) => data.STNAME),
                ),
              );
            }
          })
          .catch(error => {
            console.error(`${error.name} : ${error.message}`);
          })
          .finally(() => {
            isMounted = false;
          });
      })();
    }
  });
  const tableBody = <SimpleTableBody tableData={interstateData} />;

  return <MultiHeaderTable tableBody={tableBody} tableHeaders={tableHeaders} />;
}
